import React, { Component } from 'react';
import { Modal, Button, Table, Form, Input, Divider, message, Select, Checkbox } from 'antd';
import axios from '../../service/index'
// import { Item } from 'antd-mobile/lib/tab-bar';
import './roleManagement.less'
import { formatData } from "../../utils/util";


const { Option } = Select;
const { TextArea } = Input;
const CheckboxGroup = Checkbox.Group;

class LabelManagement extends Component {

	constructor(props) {
		super(props)
		this.state = {
			loading: true,
			visible: false,
			visiblerole: false,
			authShow: false,
			roleShow: false,
			lableListData: [],
			name: '',
			total: 0,
			searchData: {
				page: 1,
				pageSize: 10,
			},
			labelStatus: "",
			labelDescription: "",
			labelName: '',
			labelId: null,
			modelTitle: '新建角色',
			checkOptions: [],
			checkedbox: false,
			checkList: [],
			checkAllValue: [],
			checkedNum: 0,
			rolecolumns: [
				{
					title: '模块',
					dataIndex: 'title',
					expandIcon: false,
					key: 'name',
					width: 150,
					align: 'left',
					render: (text, record) => {
						return <div>
							<Checkbox onClick={this.checkClickMoudle.bind(this, record)} checked={record.checked}>{text}</Checkbox>
						</div>
					}
				},
				{
					title: '功能',
					dataIndex: 'children',
					key: 'status',
					align: 'left',
					render: (text, record) => {
						if (record) {

							return <ul className="permissions_ul">
								{
									record.child.map((item, index) => {
										let plainOptions = !!item.child && item.child.map(k => {
											return {
												label: k.title,
												value: k.id
											}
										})
										return <li key={index} className="permissions_item">
											<Checkbox
												checked={item.checked}
												onChange={this.checkClickChilden.bind(this, item)}
											// disabled={item.url === "/jurisdiction" || item.url === '/ReleaseContent'}
											>{item.title}</Checkbox>
											{item.child.length ? <div className="permissions_div">
												<div className="dottedLine"></div>
												<CheckboxGroup
													options={plainOptions}
													value={item.checkedList}
													onChange={list => this.onChange(list, item, record)}
												/>
											</div> : <></>}
										</li>
									})
								}
							</ul>

						}
					}
				}
			],
			columns: [
				{
					title: '角色',
					dataIndex: 'name',
					key: 'name',
					align: 'center'
				},
				{
					title: '状态',
					dataIndex: 'status',
					key: 'status',
					align: 'center',
					render: (record) => <div>
						{record ? "正常" : "锁定"}
					</div>
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) =>
						<div>
							{/* { record.id == 26 ? true : false } */}

							<Button style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
								this.setState({
									visible: true,
									labelName: record.name,
									labelStatus: record.status,
									labelDescription: record.description,
									modelTitle: '编辑角色',
									labelId: record.id,
									roleShow: true,
									authShow: false
								})
							}}>编辑</Button>
							<Button disabled={record.id === 26 || record.status === 0 ? true : false} style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
								this.setState({
									visible: true,
									labelName: record.name,
									labeldescription: record.description,
									modelTitle: '权限分配',
									labelId: record.id,
									lablestatus: record.status,
									authShow: true,
									roleShow: false
								})
								this.getRolelist(record.id)
							}}>权限分配</Button>
							<Button disabled={record.id === 26 ? true : false} style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
								Modal.confirm({
									title: '删除角色',
									okText: "确认",
									cancelText: "取消",
									content: (
										<div>
											<p>角色删除后将不可恢复，请谨慎操作！确定要删除吗？</p>
										</div>
									),
									onOk: () => {
										this.delLable(record.id)
									},
								});
							}}>删除</Button>
						</div>
				},
			]
		}
	}
	componentDidMount() {
		this.lableList()
	}
	showModal = (e) => {
		this.setState({
			modelTitle: '新增角色',
			visible: true,
			roleShow: true,
			authShow: false
		})
	}
	handleOk = (e) => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				if (this.state.modelTitle === '新增角色') {
					axios.post('sys/role', {
						name: values.name,
						status: values.status,
						description: values.description
					}).then(res => {
						if (res.data.code === 200) {
							message.success('添加成功')
							this.lableList()
							this.setState({
								visible: false
							})
						} else {
							message.error(res.data.msg)
						}
					})
				} else if (this.state.modelTitle === '编辑角色') {
					axios.put('sys/role', {
						id: this.state.labelId,
						name: values.name,
						status: values.status,
						description: values.description
					}).then(res => {
						if (res.data.code === 200) {
							message.success('编辑成功')
							this.lableList()
							this.setState({
								visible: false
							})
						} else {
							message.error(res.data.msg)
						}
					})
				} if (this.state.modelTitle === '权限分配') {
					let checkOptionslist = this.state.checkOptions
					let permissions = []
					checkOptionslist.forEach(item => {
						if (item.checked) {
							permissions.push(item.id)

							if (item.child.length) {//菜单层
								item.child.forEach(k => {
									if (k.checked) {
										permissions.push(k.id)
										if (k.child.length) {//按钮层
											k.child.forEach(v => {
												if (v.checked) {
													permissions.push(v.id)
												}
											})
										}
									}
								})
							}
						}
					})
					axios.put('sys/role', {
						id: this.state.labelId,
						name: this.state.labelName,
						description: this.state.labelDescription,
						status: this.state.lablestatus,
						permissions: permissions
					}).then(res => {
						if (res.data.code === 200) {
							message.success('分配成功')
							this.lableList()
							this.setState({
								visible: false
							})
						} else {
							message.error(res.data.msg)
						}
					})
				}

			}
		})
	}
	lableList = () => {
		axios.post('sys/roles', {
			...this.state.searchData,
			name: this.state.name
		}).then(res => {
			if (res.data.code === 200) {
				this.setState({
					lableListData: res.data.data.records,
					total: res.data.data.total,
					searchData: {
						pageSize: res.data.data.pageSize,
						// page: res.data.data.current
					}
				})
			}
		})
	}
	delLable(id) {
		axios.delete(`sys/role/${id}`).then(res => {
			if (res.data.code === 200) {
				message.success('删除成功')
				this.lableList()
			} else {
				message.error(res.data.msg)
			}
		})
	}
	handleCancel = () => {
		this.setState({
			visible: false,
			visiblerole: false
		})
	};
	// 权限分配
	getRolelist = async (id) => {
		await axios.get(`sys/role/${id}`).then(res => {
			if (res.data.code === 200) {
				let tempArr = formatData(res.data.data.permissionRespNodes)
				tempArr.forEach(item => {
					if (item.child && item.child.length > 0) {
						item.checked = item.child.some(caidan => { return caidan.checked })
					}
				})

				this.setState({
					checkOptions: tempArr,
					loading: false
				})
			}
		})
	}
	checkClickMoudle = (record, e) => {
		const { checkOptions } = this.state
		let moduleArr = checkOptions.map(item => {
			if (item.id === record.id) {
				item.checked = e.target.checked
				if (item.child && item.child.length) {
					item.child = item.child.map(k => {
						// k是菜单列
						k.checked = e.target.checked
						if (k.child && k.child.length) {
							k.child = k.child.map(v => {
								// v代表按钮列
								v.checked = e.target.checked
								if (e.target.checked) {
									k.checkedList.push(v.id)
								} else {
									k.checkedList = []
								}
								return v
							})
						}
						return k
					})
				}
			}
			return item
		})
		this.setState({
			checkOptions: moduleArr
		});
	}

	checkClickChilden = (record, item) => {
		item.stopPropagation()
		const { checkOptions } = this.state;
		let e = item
		let moduleArr = checkOptions.map(k => {
			// k代表点击的菜单所在的模块
			if (k.id === record.pid) {
				k.child = k.child.map(m => {
					// m是点击的某个菜单
					if (m.id === record.id) {
						m.checked = e.target.checked
						if (m.child && m.child.length) {
							// 点击菜单，按钮全部选中或取消
							m.child.forEach(b3 => {
								b3.checked = m.checked
							})
							let selectList = m.child.map(k => {
								return k.id
							})
							m.checkedList = e.target.checked ? selectList : []
						}
					}
					return m
				})
				// 模块是否要被选中
				k.checked = k.child.some(v => v.checked)
			}
			return k
		})
		this.setState({
			checkOptions: moduleArr
		});
	}
	// 按钮
	onChange = (list, item, record) => {
		const { checkOptions } = this.state;
		let moduleArr = checkOptions.map(k => {
			// k代表点击的按钮所在的模块
			if (k.id === record.id) {
				k.child = k.child.map(v => {
					// v代表点击的按钮所在的菜单
					if (v.id === item.id) {
						v.child = v.child.map(m => {
							if (list.indexOf(m.id) !== -1) {
								m.checked = true
							} else {
								m.checked = false
							}
							return m
						})
						v.checked = true
						v.checkedList = list
					}
					return v
				})
				k.checked = !!k.child && k.child.some(vm => vm.checked)
			}
			return k
		})

		this.setState({
			checkOptions: moduleArr
		});
	}



	render() {
		const { lableListData, modelTitle, columns, visible, labelName, labelStatus, labelDescription, total, checkOptions, rolecolumns, roleShow, authShow, loading } = this.state
		const { getFieldDecorator } = this.props.form;

		const pagination = {
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal: () => `共 ${total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.page = current
				searchData.pageSize = pageSize
				this.lableList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.page = current
				this.lableList(searchData)
			},
		}
		return (
			<div>
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>角色管理</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div>
						<Input allowClear value={this.state.name} style={{ width: '260px', height: '40px', marginRight: '20px' }}
							placeholder="请输入角色名称"
							onChange={(e) => {
								this.setState({
									name: e.target.value
								})
							}}
						></Input>
						<Button className='my-button-primary' type='primary' onClick={() => {
							this.lableList()
						}}>搜索</Button>
						<span className='my-button-txt' style={{ marginLeft: '20px' }} type='primary' onClick={() => {
							this.setState({
								name: ''
							}, () => {
								this.lableList()
							})
						}}>重置</span>
					</div>
					<Button className='my-button-primary' type='primary' onClick={(e) => { this.showModal(e) }}>新增角色</Button>
				</div>
				<Table dataSource={lableListData} columns={columns} rowKey={record => record.id} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')} pagination={pagination} />
				<Modal
					getContainer={true}
					title={modelTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
					maskClosable={() => { this.setState({ visible: false }) }}
					width={1000}

				>
					{roleShow && <Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.handleOk}>
						<Form.Item label={"角色名称"}>
							{getFieldDecorator('name', {
								rules: [{ required: true, message: '请输入角色名称!' }, { max: 50, message: '最多输入50个字符' }],
								initialValue: modelTitle === '编辑角色' ? labelName : ''
							})(
								<Input placeholder='请输入角色名称' />
							)}
						</Form.Item>
						<Form.Item label={"账号状态"}>
							{getFieldDecorator('status', {
								rules: [{ required: true, message: '请选择状态!' }],
								initialValue: modelTitle === '编辑角色' ? labelStatus : ''
							})(
								<Select placeholder='请选择状态'>
									<Option value={1}>正常</Option>
									<Option value={0}>锁定</Option>
								</Select>
							)}
						</Form.Item>
						<Form.Item label={"角色描述"}>
							{getFieldDecorator('description', {
								rules: [{ required: false, message: '请输入描述!' }, { max: 50, message: '最多输入50个字符' }],
								initialValue: modelTitle === '编辑角色' ? labelDescription : ''
							})(
								<TextArea placeholder='请输入角色描述' rows={4} maxLength="500" />
							)}
						</Form.Item>
					</Form>}
					{authShow && <Table loading={loading} rowKey={record => record.id} dataSource={checkOptions} columns={rolecolumns} />}
				</Modal>
			</div>
		)
	}
};

export default Form.create()(LabelManagement)